@if (languages().length > 1) {
  <ptl-button
    data-testid="content-language-menu"
    type="smoke"
    [size]="size()"
    [matMenuTriggerFor]="languageMenu"
    [icon]="LucideLanguages"
    [ariaLabel]="'translations.global.ariaLabels.icons.language' | transloco"
  ></ptl-button>

  <mat-menu #languageMenu="matMenu">
    @for (language of languages(); track language.code) {
      <button
        mat-menu-item
        class="language-menu-item"
        data-testid="content-language-option"
        [attr.data-code]="language.code"
        [class.is_active]="language.code === selectedCode()"
        [attr.aria-label]="'translations.global.ariaLabels.icons.changeLanguageTo' | transloco: { lang: language.name }"
        (click)="languageSelected.emit(language.code)"
      >
        {{ language.code.toUpperCase() }}
      </button>
    }
  </mat-menu>
}
